<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.0333 13.4413H5.13241C4.81876 13.4413 4.56214 13.1892 4.56214 12.8812V11.014C4.56214 10.7059 4.81876 10.4538 5.13241 10.4538H7.0333C7.34695 10.4538 7.60357 10.7059 7.60357 11.014V12.8812C7.60357 13.1892 7.34695 13.4413 7.0333 13.4413ZM12.1657 12.8812V11.014C12.1657 10.7059 11.9091 10.4538 11.5954 10.4538H9.69455C9.38091 10.4538 9.12429 10.7059 9.12429 11.014V12.8812C9.12429 13.1892 9.38091 13.4413 9.69455 13.4413H11.5954C11.9091 13.4413 12.1657 13.1892 12.1657 12.8812ZM16.7279 12.8812V11.014C16.7279 10.7059 16.4712 10.4538 16.1576 10.4538H14.2567C13.943 10.4538 13.6864 10.7059 13.6864 11.014V12.8812C13.6864 13.1892 13.943 13.4413 14.2567 13.4413H16.1576C16.4712 13.4413 16.7279 13.1892 16.7279 12.8812ZM12.1657 17.3624V15.4952C12.1657 15.1871 11.9091 14.9351 11.5954 14.9351H9.69455C9.38091 14.9351 9.12429 15.1871 9.12429 15.4952V17.3624C9.12429 17.6705 9.38091 17.9226 9.69455 17.9226H11.5954C11.9091 17.9226 12.1657 17.6705 12.1657 17.3624ZM7.60357 17.3624V15.4952C7.60357 15.1871 7.34695 14.9351 7.0333 14.9351H5.13241C4.81876 14.9351 4.56214 15.1871 4.56214 15.4952V17.3624C4.56214 17.6705 4.81876 17.9226 5.13241 17.9226H7.0333C7.34695 17.9226 7.60357 17.6705 7.60357 17.3624ZM16.7279 17.3624V15.4952C16.7279 15.1871 16.4712 14.9351 16.1576 14.9351H14.2567C13.943 14.9351 13.6864 15.1871 13.6864 15.4952V17.3624C13.6864 17.6705 13.943 17.9226 14.2567 17.9226H16.1576C16.4712 17.9226 16.7279 17.6705 16.7279 17.3624ZM21.29 5.22568V21.6569C21.29 22.8939 20.2683 23.8976 19.0089 23.8976H2.28107C1.02173 23.8976 0 22.8939 0 21.6569V5.22568C0 3.98867 1.02173 2.98506 2.28107 2.98506H4.56214V0.557715C4.56214 0.249629 4.81876 -0.00244141 5.13241 -0.00244141H7.0333C7.34695 -0.00244141 7.60357 0.249629 7.60357 0.557715V2.98506H13.6864V0.557715C13.6864 0.249629 13.943 -0.00244141 14.2567 -0.00244141H16.1576C16.4712 -0.00244141 16.7279 0.249629 16.7279 0.557715V2.98506H19.0089C20.2683 2.98506 21.29 3.98867 21.29 5.22568ZM19.0089 21.3769V7.46631H2.28107V21.3769C2.28107 21.5309 2.40938 21.6569 2.56621 21.6569H18.7238C18.8806 21.6569 19.0089 21.5309 19.0089 21.3769Z"
      :fill="color"
    />
  </svg>
</template>

<script setup>
defineProps({
  width: {
    type: [String, Number],
    default: 21.29,
  },
  height: {
    type: [String, Number],
    default: 23.9,
  },
  color: {
    type: String,
    default: '#FFFFFF',
  },
});
</script>
